import "styles/layout/mobile-header.less";
import { FC, useState } from "react";

import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { Col, Drawer, Modal, Row } from "antd";
import close from "assets/images/new-questionnaire/close.svg";
import taxzapLogo from "assets/images/taxzap-logo-R.svg";
import DropDownMobile from "components/pages/Profile/tabs/Homepage/DropDownMobile";
import { Link } from "react-router-dom";
import { IUser } from "types/auth";
import { AccountDetails } from "types/bankAccounts";

import SideNavigation from "./SideNavigation";
import { Step } from "../../constants/questions";
import BankAccount from "../BankAccount/BankAccount";
import ProgressDivider from "../ProgressDivider";

type HeaderProps = {
    user: IUser;
    connectedBankAccounts: AccountDetails[];
    openConnectModal: () => void;
    handleContinue: () => void;
    currentStepData: Step;
    totalProgress: number;
};

const MobileHeader: FC<HeaderProps> = ({ user, openConnectModal, handleContinue, totalProgress }) => {
    const [openBankAccounts, setOpenBankAccounts] = useState(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsNavigationMenuOpen(!isNavigationMenuOpen);
    };

    return (
        <>
            <Row className="mobile-header w100 center">
                <Col span={8} className="taLeft"><MenuOutlined className="mr4" onClick={toggleMenu}/><span className="pointer" onClick={toggleMenu}>Menu</span></Col>
                <Drawer
                    title=""
                    open={isNavigationMenuOpen}
                    onClose={toggleMenu}
                    footer={null}
                    width={"100%"}
                    placement="left"
                    closeIcon={<CloseOutlined />}
                    className="mobile-header__drawer"
                >
                    <SideNavigation close={toggleMenu}/>
                </Drawer>
                <Col span={8} className="taCenter">
                    <Link to={"profile"} className="mobile-header__profile-link">
                        <img
                            className="dblock logo-questionnaire mAuto"
                            src={taxzapLogo}
                            alt="TaxZap Logo"
                            style={{ cursor: "default" }}
                        />
                    </Link>
                </Col>

                <Col span={8} className="taRight">
                    <DropDownMobile
                        firstName={user.info.firstName} lastName={user.info.lastName} email={user.info.email}
                    />
                </Col>
            </Row>
            <ProgressDivider progress={totalProgress}/>
            <Modal
                open={openBankAccounts}
                width={355}
                destroyOnClose
                closable={false}
                onCancel={() => setOpenBankAccounts(false)}
                footer={null}
                className="shared__prompt-modal"
                styles={{
                    content: {
                        borderRadius: "20px",
                        padding: "20px!important",
                    },
                }}
                centered
            >
                <div className="new-questionnaire__bank-accounts-modal">
                    <div className="new-questionnaire__bank-accounts-close" onClick={() => setOpenBankAccounts(false)}>
                        <img src={close} alt="close" className="dblock p16"/>
                    </div>
                    <BankAccount
                        user={user}
                        handleContinue={handleContinue}
                        openConnectModal={() => {
                            openConnectModal();
                            setOpenBankAccounts(false);
                        }}
                        isHeaderComponent={true}
                    ></BankAccount>
                </div>
            </Modal>
        </>
    );
};

export default MobileHeader;
